import React from "react";
import DocumentAchatEntity from "./DocumentAchatEntity";

const BonRetourAchat = () => {
    return <DocumentAchatEntity type="Bon Retour" title="Bons Retour" endpoint="BonRetourAchat" />;
};

export default BonRetourAchat;